import React from 'react';
import { useAppStore } from '../../store';
import { calculateTrends } from '../../utils/analytics';
import { ArrowUp, ArrowDown } from 'lucide-react';

export const AnalyticsSummary = () => {
  const tasks = useAppStore((state) => state.tasks);
  const trends = calculateTrends(tasks);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Performance Summary
      </h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">Task Completion</p>
          <div className="flex items-center mt-1">
            <span className="text-2xl font-bold text-gray-900 dark:text-white">
              {trends.completionRate}%
            </span>
            <span className={`ml-2 flex items-center text-sm ${
              trends.completionTrend > 0 
                ? 'text-green-600' 
                : 'text-red-600'
            }`}>
              {trends.completionTrend > 0 ? (
                <ArrowUp className="w-4 h-4 mr-1" />
              ) : (
                <ArrowDown className="w-4 h-4 mr-1" />
              )}
              {Math.abs(trends.completionTrend)}%
            </span>
          </div>
        </div>
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">Efficiency</p>
          <div className="flex items-center mt-1">
            <span className="text-2xl font-bold text-gray-900 dark:text-white">
              {trends.efficiency}%
            </span>
            <span className={`ml-2 flex items-center text-sm ${
              trends.efficiencyTrend > 0 
                ? 'text-green-600' 
                : 'text-red-600'
            }`}>
              {trends.efficiencyTrend > 0 ? (
                <ArrowUp className="w-4 h-4 mr-1" />
              ) : (
                <ArrowDown className="w-4 h-4 mr-1" />
              )}
              {Math.abs(trends.efficiencyTrend)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};